module.exports = __webpack_public_path__ + "img/info.171ce4e4.svg";